import { useState } from 'react';
import { Button, FormControlLabel, Radio, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Modal from 'common/modal';

const useStyles = makeStyles(() => ({
  content: {
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    color: '#1C2541',
  },
  title: {
    fontWeight: 700,
    fontSize: '24px',
    marginTop: '18px',
    marginBottom: '20px',
    alignSelf: 'left',
  },
  mainContent: {
    marginTop: '32px',
  },
  generateButton: {
    padding: '18px 0',
    borderRadius: '100px',
    maxHeight: '40px',
    marginTop: '20px',
    marginBottom: '20px',
    backgroundColor: '#5ED1F0',
    color: '#1C2541',
  },
  cancelButton: {
    padding: '18px 0',
    borderRadius: '100px',
    maxHeight: '40px',
    marginTop: '40px',
    backgroundColor: '#fff',
    color: '#1C2541',
    border: '2px solid #1C2541',
  },
  radioContainer: {
    border: '2px solid #E0E0E0',
    padding: '10px',
    borderRadius: '8px',
    marginBottom: '20px',
  },
  italics: {
    fontStyle: 'italic',
    fontSize: '14px',
  },
}));

type Props = {
  onClose: () => void;
  onGenerateDocument: (keepEmptyPlaceholders: boolean) => void;
};

const IncompleteFieldsPromptModal = ({ onClose, onGenerateDocument }: Props) => {
  const classes = useStyles();
  const [keepEmptyPlaceholders, setKeepEmptyPlaceholders] = useState(false);

  const handleGenerateClick = () => {
    onGenerateDocument(keepEmptyPlaceholders);
    onClose();
  };

  return (
    <Modal
      setShowModal={onClose}
      onExitClick={onClose}
      showModal
      showActions={false}
      content={
        <div className={classes.content}>
          <Typography className={classes.title}>Incomplete Fields</Typography>
          <Typography>
            Some fields in the document haven't been filled out.
            <br />
            How would you like the fields to appear when generating the document?
          </Typography>
          <div className={classes.mainContent}>
            <div className={classes.radioContainer} onClick={() => setKeepEmptyPlaceholders(false)}>
              <FormControlLabel
                control={<Radio key="keepEmpty" checked={!keepEmptyPlaceholders} />}
                label="Leave the fields empty in the document"
              />
            </div>
            <div className={classes.radioContainer} onClick={() => setKeepEmptyPlaceholders(true)}>
              <FormControlLabel
                control={<Radio key="useDefault" checked={keepEmptyPlaceholders} />}
                label={
                  <div>
                    <div>Use default descriptions for empty fields</div>
                    <div className={classes.italics}>
                      {"For example 'The account is held at {{InstitutionName}}"}
                    </div>
                  </div>
                }
              />
            </div>
          </div>
          <Button type="button" variant="outlined" className={classes.cancelButton}>
            Cancel
          </Button>
          <Button
            type="button"
            variant="outlined"
            className={classes.generateButton}
            onClick={handleGenerateClick}
          >
            Generate
          </Button>
        </div>
      }
      loading={false}
      actionDisabled={false}
      maxWidth="sm"
    />
  );
};

export default IncompleteFieldsPromptModal;
